import { useEffect, useState } from "react";

/**
 * Live elapsed time in whole seconds, ticking once a second while the call is
 * up. Shared by the operator's own call and the AI call dock, so both clocks
 * count the same way.
 */
export function useElapsed(answeredAt: number | null): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!answeredAt) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [answeredAt]);
  return answeredAt ? Math.max(0, Math.round((now - answeredAt) / 1000)) : 0;
}
